export default "//yastatic.net/s3/distribution/pythia/frontend/_/0a83937a101d78f792b3984d58fc8c43.jpeg";